import React, { useState } from "react";
import { Button } from "../common/Button";
import { Modal } from "../common/Modal";

type FeedbackPromptProps = {
  orderId: string;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: { rating: number; comment: string }) => void;
};

const FeedbackPrompt: React.FC<FeedbackPromptProps> = ({
  orderId,
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ rating, comment });
    setRating(5);
    setComment("");
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Rate Your Order">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="form-group">
          <label className="form-label">Rating (1-5)</label>
          <input
            type="number"
            min="1"
            max="5"
            className="form-control"
            value={rating}
            onChange={(e) => setRating(Number(e.target.value))}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Comments</label>
          <textarea
            className="form-control"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Share your experience..."
            rows={4}
          />
        </div>
        <div className="flex gap-2">
          <Button type="submit" variant="primary">
            Submit Feedback
          </Button>
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default FeedbackPrompt;
